import { ProductListPageHitV1, SelectItemProductListClickV1, SelectContentProductListClickV1 } from '@inditex/resellanl-ianalytics-events';
import { buildEvent } from '../helpers/build-event';
import { normalizeUniverse } from '../helpers/normalize-universe';

export const PRODUCT_LIST_PAGE_HIT = ({ data }: { data?: unknown }) => {
  const payload = data as {
    universe?: string;
    categoryId?: number;
  };

  return buildEvent({
    Event: ProductListPageHitV1,
    payload: {
      universe: normalizeUniverse(payload?.universe),
      categoryId: Number(payload?.categoryId),
    },
  });
};

export const SELECT_CONTENT_PRODUCT_LIST_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    contentValue?: string;
  };

  return buildEvent({
    Event: SelectContentProductListClickV1,
    payload: {
      contentValue: payload?.contentValue,
    }
  });
};

export const SELECT_ITEM_PRODUCT_LIST_CLICK = ({ data }: { data?: unknown }) => {
  const payload = data as {
    listPosition?: number;
    productGroupId?: number | null;
    productId?: number;
    section?: string;
  };

  return buildEvent({
    Event: SelectItemProductListClickV1,
    payload: {
      listPosition: Number(payload?.listPosition),
      productGroupId: payload?.productGroupId ?? null,
      productId: Number(payload?.productId),
      section: normalizeUniverse(payload?.section),
    },
  });
};
